import request from '@/utils/request'

const url = 'admin/site.space_date_price'

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },
  EditPayload(id) {
    return request({
      url: `${url}/editPayload`,
      method: 'post',
      params: { id }
    })
  },
  InitDay(data) {
    return request({
      url: `${url}/initDay`,
      method: 'post',
      data
    })
  },
  Save(data) {
    return request({
      url: `${url}/save`,
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  }
}

export default api
